var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[_c('v-app-bar',{attrs:{"app":"","dense":"","color":"primary"}},[_c('div',{staticClass:"d-flex align-center"},[_vm._v(" WebMUDs Test ")]),_c('v-spacer'),_vm._v(" --- ")],1),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }